import React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';

const Table = ({ children }) => {
  return (
    <ScrollContainer
      className="componentTable"
      hideScrollbars={false}
      ignoreElements="input, textarea, select, button, [data-no-drag]"
    // optionnel : tu peux réduire la distance avant drag si tu veux
    // activationDistance={10}
    >
      <table>{children}</table>
    </ScrollContainer>
  );
};

export default Table;